"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.parse-int");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alphaColour = alphaColour;
exports["default"] = void 0;

function alphaColour(hexValue, percentage) {
  // Convert Hex with alpha values to RGBA()
  var red = parseInt(hexValue.substring(1, 3), 16);
  var green = parseInt(hexValue.substring(3, 5), 16);
  var blue = parseInt(hexValue.substring(5, 8), 16);
  return "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(percentage / 100, ")");
}

var _default = alphaColour;
exports["default"] = _default;